import React, { useEffect, useState } from "react";
import SurakshaSolutionCard from "./Surakshasolutioncard";
import { http } from "../../axios/axios";
import SectionHeader from "../SectionHeader";
import { Box } from "lucide-react";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";

export default function Solutionsuraksha() {
  const [solutions, setSolutions] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchSolutions = async () => {
    try {
      const res = await http.get("/solutions");

      setSolutions(res.data?.data || []);
    } catch (err) {
      console.error(
        "Error fetching security solutions:",
        err.response?.data || err.message
      );

      setSolutions([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSolutions();
  }, []);

  return (
    <section className="px-4 sm:px-6 lg:px-8 py-5 md:py-6">
      <SectionHeader
        badge="Our Expertise"
        title="Smart Surveillance & Security Solutions"
        description={
          <span className="lg:whitespace-nowrap">
            Advanced Security Surveillance and IT product solutions designed for homes, offices, commercial spaces, and industries.
          </span>
        }
        showLine={true}
        sideTitle={null}
        sideSubtitle={null}
      />

      {loading ? (
        <div className="flex justify-center py-20">
          <div className="h-12 w-12 animate-spin rounded-full border-b-2 border-blue-700" />
        </div>
      ) : solutions.length > 0 ? (
        <Swiper
          modules={[Autoplay, Pagination]}
          spaceBetween={24}
          speed={800}
          loop={solutions.length > 3}
          autoplay={
            solutions.length > 3
              ? {
                  delay: 5000,
                  disableOnInteraction: false,
                  pauseOnMouseEnter: true,
                }
              : false
          }
          pagination={{
            clickable: true,
          }}
          breakpoints={{
            0: {
              slidesPerView: 1,
              spaceBetween: 16,
            },

            640: {
              slidesPerView: 2,
              spaceBetween: 20,
            },

            1024: {
              slidesPerView: 3,
              spaceBetween: 24,
            },
          }}
          className="pb-12"
        >
          {solutions.map((solution, index) => (
            <SwiperSlide
              key={solution._id || index}
              className="h-auto p-6"
            >
              <SurakshaSolutionCard
                solution={solution}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      ) : (
        <div
          className="
            py-20
            text-center
            border
            border-dashed
            border-slate-300
            rounded-2xl
            bg-slate-50
          "
        >
          <Box
            size={40}
            className="mx-auto text-slate-300 mb-4"
          />

          <h3 className="text-lg font-semibold text-slate-700 mb-2">
            No Solutions Available
          </h3>

          <p className="text-sm text-slate-500">
            We are currently updating our Solutions. Please check back soon.
          </p>
        </div>
      )}
    </section>
  );
}